<template functional>
  <b-card
    class="mb-2"
    :class="[data.class, data.staticClass, 'bg-' + props.variant]"
    :style="[data.style, data.staticStyle]">
    <b-card-text>
      <p class="mb-0 font-weight-bold">{{ props.user }} @ {{ props.timestamp }}</p>
      <p class="mb-0">
        {{ props.text }}
      </p>
    </b-card-text>
  </b-card>
</template>
<script>
export default {
  functional: true,

  props: {
    alternate: {
      type: Boolean,
      default: false
    },

    user: {
      type: String,
      required: true
    },

    text: {
      type: String,
      required: true,
    },

    timestamp: {
      type: String,
      required: true
    },

    variant: {
      type: String,
      default: 'primary'
    }
  },
};
</script>
